import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  AccessabilityDialogComponent,
  AccessabilityDialogData,
} from '@components/dialogs/accessability-dialog/accessability-dialog.component';
import { UserOnlineScreening } from '@shared/graphql/account.generated';
import {
  Episode,
  EpisodeAccessType,
  EpisodePageResult,
  EpisodeReleaseStatus,
  GetEpisodeByUidDocument,
  GetEpisodeByUidQueryVariables,
  GetEpisodeDocument,
  GetEpisodePageByIdDocument,
  GetEpisodePageByIdQueryVariables,
  GetEpisodePageByUidDocument,
  GetEpisodePageByUidQueryVariables,
  GetEpisodeQueryVariables,
  PlayableEpisode,
  PlayableEpisodeResult,
} from '@shared/graphql/api.generated';
import { GraphqlClients, GraphqlService } from '@shared/graphql/graphql.service';
import { TokenService } from '@shared/services/token.service';
import { GeneralService } from './general.service';

@Injectable()
export class EpisodeService {
  private readonly graphqlService = inject(GraphqlService);
  private readonly tokenService = inject(TokenService);
  private readonly generalService = inject(GeneralService);
  private readonly dialog = inject(MatDialog);

  getEpisodeById(episodeID: string) {
    return this.graphqlService.makeQuery<PlayableEpisodeResult, GetEpisodeQueryVariables>(
      GraphqlClients.api,
      GetEpisodeDocument,
      {
        episodeID,
      },
    );
  }

  getEpisodeByUid(uid: string) {
    return this.graphqlService.makeQuery<PlayableEpisodeResult, GetEpisodeByUidQueryVariables>(
      GraphqlClients.api,
      GetEpisodeByUidDocument,
      {
        uid,
      },
    );
  }

  getEpisodePage(uid: string) {
    return this.graphqlService.makeQuery<EpisodePageResult, GetEpisodePageByUidQueryVariables>(
      GraphqlClients.api,
      GetEpisodePageByUidDocument,
      {
        uid,
      },
    );
  }

  getEpisodePageById(episodeID: string) {
    return this.graphqlService.makeQuery<EpisodePageResult, GetEpisodePageByIdQueryVariables>(
      GraphqlClients.api,
      GetEpisodePageByIdDocument,
      {
        episodeID,
      },
    );
  }

  checkEpisodeDisplay(
    episode: Episode | PlayableEpisode,
    userOnlineScreening?: UserOnlineScreening,
  ): boolean {
    if (this.generalService.isBrowserOnly) {
      if (this.tokenService.userInfo()) {
        if (episode.releaseStatus === EpisodeReleaseStatus.Released) {
          if (episode.accessType === EpisodeAccessType.Free) {
            return true;
          } else if (episode.accessType === EpisodeAccessType.SubReq) {
            if (this.generalService.freeIsp) {
              return true;
            }
            if (this.tokenService.userInfo()?.activeSubscription?.id) {
              return true;
            }
            const data: AccessabilityDialogData = {
              title: 'شما اشتراک فعالی ندارید',
              message: 'برای تماشای این محتوا باید اشتراک بخرید',
              redirectLink: '/account/plans',
              linkTitle: 'خرید اشتراک',
            };
            this.dialog.open(AccessabilityDialogComponent, {
              data,
            });
            return false;
          } else {
            if (userOnlineScreening) {
              return true;
            }
            const data: AccessabilityDialogData = {
              title: 'شما بلیط این محتوا را ندارید.',
              message: 'برای تماشای این محتوا باید بلیط بخرید',
              redirectLink: '/',
              linkTitle: 'خرید بلیط',
            };
            this.dialog.open(AccessabilityDialogComponent, {
              data,
            });
            return false;
          }
        }
        return false;
      }
    }
    this.dialog.open(AccessabilityDialogComponent);
    return false;
  }
}
